import { RouteNamesEnum } from '@/enums/RouteNamesEnum';

const SettingsRoutes = [
    {
        path: '/settings',
        component: () => import('../components/general/RootModule.vue'),
        meta: {
            title: 'SettingsModule.name',
            auth: {
                required: true,
            },
            showInMenu: false,
            moduleRoot: true,
        },
        children: [
            {
                path: 'users/:id(\\d+|new)?',
                name: RouteNamesEnum.Users,
                component: () => import('../views/settings-module/UsersView.vue'),
                meta: {
                    title: 'UsersModule.name',
                    auth: {
                        required: true,
                    },
                    canAny: ['admin'],
                    showInMenu: true,
                },
            },
            {
                path: 'locations/:id(\\d+|new)?',
                name: RouteNamesEnum.Locations,
                component: () => import('../views/settings-module/LocationsView.vue'),
                meta: {
                    title: 'SettingsModule.locations',
                    auth: {
                        required: true,
                    },
                    canAny: ['admin'],
                    showInMenu: true,
                },
            },
        ],
    },
];

export default SettingsRoutes;
